
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "VTasks"
})
export default class VTasks extends Vue {}
